<div class="fly-grammar-pwr-modal">
  <div class="modal-overlay"></div>
  <div class="modal-content">
    <header class="modal-header">
      <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="4" r="4" fill="white" />
      </svg>
      <strong>FlyGrammar</strong>
      &nbsp;- You're out of your <span class="quota"></span> actions for today.
    </header>
    <section class="modal-body">
      <button class="replacement-button">FlyGrammar</button>
      <footer class="modal-footer">
        <div class="modal-footer-text">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="48" height="48" fill="white" />
            <path
              d="M38.8067 10.4841C38.7811 10.3944 38.735 10.3177 38.6682 10.2433C38.6564 10.2299 38.6442 10.2167 38.6313 10.2038L32.6317 4.20419C32.6188 4.1913 32.6056 4.17903 32.5922 4.16724C32.5178 4.10052 32.4411 4.05435 32.3513 4.02873C32.2798 4.00615 32.2051 3.9974 32.1286 4.0042H10.1666C9.76662 4.0042 9.5 4.27082 9.5 4.67079V43.3348C9.5 43.7348 9.76662 44.0014 10.1666 44.0014H38.1647C38.5646 44.0014 38.8313 43.7348 38.8313 43.3348V10.7069C38.838 10.6305 38.8293 10.5556 38.8067 10.4841ZM36.5648 10.0039H32.8317V6.27076L36.5648 10.0039ZM10.8332 42.6683V5.33747H31.4984V10.6705C31.4984 11.0704 31.765 11.3371 32.165 11.3371H37.498V42.6683H10.8332Z"
              fill="#999999"
            />
            <path
              d="M31.6655 15H15.6666C15.2666 15 15 15.2666 15 15.6666C15 16.0666 15.2666 16.3332 15.6666 16.3332H31.6655C32.0655 16.3332 32.3321 16.0666 32.3321 15.6666C32.3321 15.2666 32.0655 15 31.6655 15Z"
              fill="#999999"
            />
            <path
              d="M26.3325 20.3332C26.7325 20.3332 26.9991 20.0666 26.9991 19.6666C26.9991 19.2666 26.7325 19 26.3325 19H15.6666C15.2666 19 15 19.2666 15 19.6666C15 20.0666 15.2666 20.3332 15.6666 20.3332H26.3325Z"
              fill="#999999"
            />
            <path
              d="M15.6666 12.3332H26.3325C26.7325 12.3332 26.9991 12.0666 26.9991 11.6666C26.9991 11.2666 26.7325 11 26.3325 11H15.6666C15.2666 11 15 11.2666 15 11.6666C15 12.0666 15.2666 12.3332 15.6666 12.3332Z"
              fill="#999999"
            />
            <path
              d="M36.6398 40.2277H15.8591L21.1744 37.5174C21.2081 37.5002 21.2388 37.4779 21.2655 37.4512L34.6169 24.0998C34.83 23.8867 34.9474 23.6033 34.9474 23.3019C34.9474 23.0005 34.83 22.7171 34.6169 22.504L32.444 20.331C32.2309 20.1179 31.9475 20.0005 31.6461 20.0005C31.3447 20.0005 31.0613 20.1179 30.8482 20.331L17.4968 33.6825C17.4701 33.7091 17.4477 33.7399 17.4306 33.7735L14.0393 40.4243C13.9684 40.5633 13.9951 40.7322 14.1055 40.8425C14.1747 40.9117 14.2668 40.948 14.3603 40.948C14.3689 40.948 36.6399 40.948 36.6399 40.948C36.8387 40.948 37 40.7867 37 40.5878C37 40.3889 36.8387 40.2277 36.6398 40.2277ZM34.1077 23.0133C34.1847 23.0903 34.2272 23.1928 34.2272 23.3018C34.2272 23.4109 34.1848 23.5133 34.1077 23.5905L21.0109 36.6873L20.5598 36.2362L33.9452 22.8508L34.1077 23.0133ZM32.6064 21.512L33.4359 22.3415L20.0506 35.7269L19.221 34.8974L32.6064 21.512ZM31.3575 20.8403C31.4345 20.7632 31.5371 20.7207 31.6461 20.7207C31.7551 20.7207 31.8576 20.7631 31.9347 20.8403L32.0971 21.0027L18.7118 34.3881L18.2607 33.937L31.3575 20.8403ZM17.8471 34.5421L20.4058 37.1008L18.0531 38.3005L16.6474 36.8948L17.8471 34.5421ZM16.3035 37.5694L17.3785 38.6445L15.1849 39.7631L16.3035 37.5694Z"
              fill="#999999"
            />
            <path
              d="M35.4858 38.719H20.5047C20.3058 38.719 20.1445 38.8802 20.1445 39.0791C20.1445 39.278 20.3058 39.4393 20.5047 39.4393H35.4859C35.6847 39.4393 35.846 39.278 35.846 39.0791C35.846 38.8802 35.6847 38.719 35.4858 38.719Z"
              fill="#999999"
            />
            <path
              d="M34.3373 37.179H22.8133C22.6144 37.179 22.4531 37.3401 22.4531 37.5391C22.4531 37.738 22.6143 37.8992 22.8133 37.8992H34.3372C34.5361 37.8992 34.6974 37.738 34.6974 37.5391C34.6974 37.3402 34.5361 37.179 34.3373 37.179Z"
              fill="#999999"
            />
            <path
              d="M33.1815 35.6445H24.3465C24.1476 35.6445 23.9863 35.8058 23.9863 36.0047C23.9863 36.2035 24.1476 36.3648 24.3465 36.3648H33.1815C33.3804 36.3648 33.5416 36.2036 33.5416 36.0047C33.5416 35.8058 33.3804 35.6445 33.1815 35.6445Z"
              fill="#999999"
            />
          </svg>

          <h3 class="upgrade-message"></h3>
        </div>
        <div class="modal-footer-buttons">
          <button class="modal-footer-button-primary">Upgrade</button>
          <button class="modal-footer-button-secondary">Dismiss</button>
        </div>
      </footer>
    </section>
  </div>
</div>
